// eslint-disable-next-line no-restricted-imports -- TODO: legacy styled-components (baseline)
import styled from 'styled-components/macro';

// TODO: module constant not in UPPER_SNAKE_CASE (README, Conventions: JavaScript)
const headerFont = `'Inter', 'Open Sans', sans-serif`;

export const NavBarWrapper = styled.div`
    position: sticky;
    top: 0;
    z-index: 2003;

    width: 100%;
    height: 48px;

    color: #1f2937;
    font-family: ${headerFont};

    background-color: ${props => (props.prospectMode ? 'var(--backgroundColorSecondary)' : '#ffffff')};
    box-shadow: 0 1px 0 rgba(15, 23, 42, 0.08);
    overflow: visible;

    text-transform: none;

    a {
        // color: inherit;
        text-decoration: none;
    }
`;

export const Brand = styled.div`
    display: flex;
    align-items: center;
    flex: none;

    cursor: pointer;

    img {
        display: block;
        height: 28px;
        width: auto;
    }
`;

export const HeaderStart = styled.div`
    display: flex;
    align-items: center;
    flex: 1;
    min-width: 0;
    gap: 10px;
    height: 100%;

    @media (max-width: 1024px) {
        gap: 6px;
    }
`;

export const HeaderCenter = styled.div`
    display: flex;
    flex: none;
    justify-content: center;
    align-items: center;
    height: 100%;
`;

export const HeaderEnd = styled.div`
    display: flex;
    flex: ${props => (props.balanced ? 1 : 'none')};
    justify-content: flex-end;
    align-items: center;
    gap: 8px;
    min-width: 0;
    height: 100%;
`;

export const HeaderSearchSlot = styled.div`
    flex: 1;
    min-width: 96px;
    max-width: 520px;
    transition: max-width 180ms ease, min-width 180ms ease;

    &:has(input) {
        min-width: 140px;
        max-width: 720px;
    }

    > div {
        width: 100%;
    }

    @media (max-width: 1024px) {
        min-width: 72px;
        max-width: none;
        flex: 1 1 auto;
    }
`;
